<template>
  <div class="beneficiary-block">
    <v-sheet :width="'100%'" :elevation="4">
      <v-container>
        <v-row>
          <v-col cols="4">
            <BeneficiaryForm
              title="Primary Beneficiary"
              :beneficiary="beneficiaries[0] || emptyBeneficiary1"
              :baseData="baseData"
              :beneficiary_number="1"
              :lead_id="lead_id"
            />
          </v-col>
          <v-col cols="4">
            <BeneficiaryForm
              title="Secondary Beneficiary"
              :beneficiary="beneficiaries[1] || emptyBeneficiary2"
              :baseData="baseData"
              :beneficiary_number="2"
              :lead_id="lead_id"
            />
          </v-col>
          <v-col cols="4">
            <BeneficiaryForm
              title="Tertiary beneficiary"
              :beneficiary="beneficiaries[2] || emptyBeneficiary3"
              :baseData="baseData"
              :beneficiary_number="3"
              :lead_id="lead_id"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BeneficiaryForm from "@/components/forms/BeneficiaryForm";

export default {
  name: "BeneficiaryBlock",
  props: {
    baseData: Object,
    lead_id: Number,
  },
  components: {
    BeneficiaryForm,
    // BeneficiaryDialog,
  },
  data() {
    return {
      emptyBeneficiary1: {
        name: "",
        relative_id: null,
        dob: "",
        location: null,
        work_status: null,
        percent: 1,
      },
      emptyBeneficiary2: {
        name: "",
        relative_id: null,
        dob: "",
        location: null,
        work_status: null,
        percent: 1,
      },
      emptyBeneficiary3: {
        name: "",
        relative_id: null,
        dob: "",
        location: null,
        work_status: null,
        percent: 1,
      },
    };
  },
  computed: {
    ...mapGetters({
      beneficiaries: "lead/beneficiaries",
    }),
  },
};
</script>
